import {BonusComponentController} from './BonusComponentController';
import {stall, stallAndReturn} from "../../../../app/shared/common";

const $inject = [
  'WizardHandler',
  '$scope',
  '$state',
  'BonusService',
  'customerService',
  'moment',
  'vbmData',
  'Made',
  '$timeout',
  'employeeService',
  'SliderOptionsConstants',
  'SteuerklassenConstants',
  'vbmService',
  'dialogService',
  '$window',
  'administrationService',
  'lodash',
  '$filter'
];

export class BonusComponentControllerDigitalEssensmarken extends BonusComponentController {
  constructor(
    WizardHandler,
    $scope,
    $state,
    BonusService,
    customerService,
    moment,
    vbmData,
    Made,
    $timeout,
    employeeService,
    SliderOptionsConstants,
    SteuerklassenConstants,
    vbmService,
    dialogService,
    $window,
    administrationService,
    lodash,
    $filter
  ) {

    super(
      WizardHandler,
      $scope,
      $state,
      BonusService,
      customerService,
      moment,
      vbmData,
      Made,
      $timeout,
      employeeService,
      SliderOptionsConstants,
      SteuerklassenConstants,
      vbmService,
      dialogService,
      $window,
      administrationService,
      lodash,
      $filter
    );

    this.loading.child = true;
    this.loading.step1 = false;
    this.loading.step2 = false;
    this.digitalEssensMarkenValidation = {
      step1: {
        success: true,
        error: ''
      },
      step2: {
        success: true,
        error: '',
      },
      step3: {
        success: false,
        error: '',
      }
    }

    this.sliderData = {
      workingDays: 5,
      options: {
        to: 5,
        step: 1,
        from: 1,
        ...angular.copy(this.SliderOptionsConstants)
      }
    }


    this.baseInitPromise.then(() => {
      return this.init();
    }).finally(() => {
      this.$timeout(() => {
        this.loading.child = false;
      }, 0);
    });
  }

  async init() {
    await this.validateStep1();
  }

  async validateStep1() {
    console.log("Validate step 1")
    try {
      await this.BonusService.digitalVouchersValidations(this.employee_id)
    } catch (e) {
      this.digitalEssensMarkenValidation.step1.success = false;
      if (e.error && e.error.message) {
        this.digitalEssensMarkenValidation.step1.error = "Bitte beachten Sie, dass Sie das Produkt “Essensmarken” bereits beziehen oder kein Budget mehr zur Verfügung haben.";
      } else {
        this.digitalEssensMarkenValidation.step1.error = 'Fehlgeschlagen'
      }
    }
  }

  canContinue() {
    return this.digitalEssensMarkenValidation.step1.success
  }

  step2SelectionPossible() {
    return true;
  }

  async validateStep2() {
    console.log("Validate step 2")
    let employeeApplied = false;
    try {
      employeeApplied = await this.BonusService.isEmployeeAlreadyAppliedForDigitalVoucher(this.employee_id, this.bonus_project_id)
    } catch (e) {
      this.digitalEssensMarkenValidation.step2.success = false;
      this.digitalEssensMarkenValidation.step2.error = 'Fehlgeschlagen'
    }

    if (employeeApplied) {
      this.digitalEssensMarkenValidation.step2.success = false;
      this.digitalEssensMarkenValidation.step2.error = "Bitte beachten Sie, dass digitale Essensmarken bereits aktiviert wurden. Wenn Sie diese wieder deaktivieren möchten, wenden Sie sich gerne an unseren Kundensupport.";
    }

  }

  wizardCanceled() {
    this.navigateBackToDashboard();
  }

  wizardFinished() {
    // do nothing
  }

  async stepValuesHandler() {
    this.$timeout(() => {
      this.loading.step2 = true;
    }, 0);
    let res = null;
    try {
      res = await this.BonusService.makeEmployeeEligibleForDigitalVouchers(
        this.employee_id,
        this.bonus_project_id,
        this.sliderData.workingDays,
      )
      this.digitalEssensMarkenValidation.step3.success = true;
    } catch (e) {

    }

    if (!res) {
      this.digitalEssensMarkenValidation.step3.success = false;
      this.digitalEssensMarkenValidation.step3.error = "Fehlgeschlagen";
    }
    this.$timeout(() => {
      this.loading.step2 = false;
    }, 0);
  }

  toAllowComponentAddition() {
    if (this.loading.step1 || this.loading.step2) {
      return false;
    }

    if (!this.digitalEssensMarkenValidation.step3.success && this.digitalEssensMarkenValidation.step3.error) {
      return false;
    }

    return !(
      !this.digitalEssensMarkenValidation.step2.success && this.digitalEssensMarkenValidation.step2.error ||
      this.digitalEssensMarkenValidation.step3.success && !this.digitalEssensMarkenValidation.step3.error
    )
  }

  async addComponentToEmployeeBonusComponents(move_to_next_step = true) {
    this.workingDaysWatcher = this.$scope.$watch(() => {
      return this.sliderData.workingDays;
    }, async (newValue, oldValue) => {
      if (!angular.equals(newValue, oldValue)) {
        this.sliderData.workingDays = newValue;
      }
    });

    this.$timeout(() => {
      this.loading.step1 = true;
    }, 0);

    await this.validateStep2();

    this.$timeout(() => {
      this.loading.step1 = false;
    }, 0);

    this.$scope.$on('$destroy', () => {
      this.workingDaysWatcher();
    });

    this.$timeout(() => {
      const wizard = this.WizardHandler.wizard();
      if (wizard && typeof wizard.next === 'function') {
        wizard.next();
      }
    }, 0);
    return true;
  }
}

BonusComponentControllerDigitalEssensmarken.$inject = $inject;
